// extracted by mini-css-extract-plugin
export default {"textArea":"AddEmail_textArea__-945C","response":"AddEmail_response__TCa06","root":"AddEmail_root__Ptg2G"};